<template>
  <div>
      <o-p-detail-provider-component/>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>